module.exports = __webpack_public_path__ + "static/logo-white-74c4f56a17ac7f68aa3632f1b0114bb5.webp";